import React from "react";
import { Button, Textarea, Select } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { useServerApi } from "../hooks/userServerApi";
import { useTranslation } from "react-i18next";
import { ENUM_FORM_DISPLAY } from "./pageList";
import { useFormRender } from "../hooks/useFormRender";
import _ from "lodash";

const RenewalReceivedButton = ({ mainForm, disabled = false }) => {
  const [api] = useServerApi();
  const { t } = useTranslation();

  const receivedRenewal = _.get(mainForm.values, "receivedRenewal");
  if (!receivedRenewal) {
    _.set(mainForm.values, "receivedRenewal", {});
  }

  const schema = {
    title: "Renewal Received",
    description: "Please fill in the received details",
    initialValues: receivedRenewal,
    display: {
      mode: ENUM_FORM_DISPLAY.MODAL,
      size: "xl", //xs, sm, xl  ....100%
    },

    layout: {
      containers: [],

      fields: [
        {
          name: "receivedRenewal.date",
          component: DatePicker,
          type: "datePicker",
          props: {
            required: true,
            label: "Received Date",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
            type: "datePicker",
          },
        },
        {
          name: "receivedRenewal.remark",
          component: Textarea,
          props: {
            label: "Remark",
          },
        },
      ],
    },
  };

  const onSubmit = async ({ values, formMode }) => {
    try {
      // values.status = "WAIT";
      mainForm.updateAndSave(values);
      formAction.close();
    } catch (error) {
      console.log(error);
    }
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    schema,
    null,
    onSubmit
  );

  const handleActionClick = () => {
    const id = mainForm?.values._id;
    if (!id) return;
    formAction.open({ mode: "edit", id, data: mainForm.values });
  };

  return (
    <>
      <Button
        fullWidth
        color="blue"
        onClick={handleActionClick}
        disabled={disabled || !mainForm.values._id}
      >
        {t("Receive Renewal")}
      </Button>
      {renderForm()}
    </>
  );
};

export default RenewalReceivedButton;
